import { ChainName } from './name'

export const CHAIN_NATIVE_TOKEN = {
  [ChainName.ETHEREUM]: 'ETH',
  [ChainName.ALGORAND]: 'ALGO',
  [ChainName.STELLAR]: 'XLM',
  [ChainName.BASE]: 'BASE'
}
